<template>
  <v-container>
    <div v-if="show">
      <section>
        <div
          class="container pt-11 pb-4 text-center"
          style="position: relative;"
        >
          <a
            @click="redirectToArticles"
            style="position: absolute; right: 0; padding-right: 10px; color: #7DC5C9"
          >
            Gå til
            artikler

          </a>
          <!-- Remove this when "Publisering" is added to the menu -->
          <h1>SALONG-INNSTILLINGER</h1>
          <hr
            class="my-4"
            style="width: 100px; border-color: #808080; margin: 0 auto;"
          />
          <p class="text-muted lead font-weight-normal">
            Klikk inn på salong, ansatte eller booking for å se om du har fyllt inn alle felter slik at din
            salong blir presentert på en god måte på nett.
          </p>
        </div>
        <div class="container">

          <div
            id="salong-card-container"
            class="row justify-content-center"
            style="margin-right: 0px !important; margin-left: 0px !important;"
          >

            <div
              class="col-6 col-sm-4 col-md-3 col-xl-2"
              style="margin-bottom: 20px; padding: 0 12px !important;"
              v-for="page in filteredPages"
              :key="page.title"
            >
            <div v-if="page.isAddon">
              <add-on-tile :addon="addons.find(x => x.EnumTypeId === webshopAddOnId)" :show="page.visible"></add-on-tile>
            </div>
              <div
              v-else
                @click="pageClicked(page)"
                role="button"
                class="card card-shadow-hover bg-secondary text-white py-1"
                style="height: 110px;"
                data-bind="with: params, style: params.style"
              >
                <div
                  v-if="!page.layout || page.layout == 1"
                  class="text-center"
                >
                  <div
                    v-if="!page.material"
                    style="font-size: 3.5rem; line-height: 1.5;"
                    :class="'icon-'+page.icon"
                  ></div>
                  <div><v-icon style="font-size: 3.5rem; line-height: 1.5;" v-if="page.material" color="white" large>{{page.icon}}</v-icon></div>
                  <div>{{ page.title }}</div>
                </div>
                <div
                  v-if="!page.layout || page.layout == 1"
                  class="card-overlay card-hover"
                >
                  <div class="card-body text-white px-0">
                    <p class="card-text text-center">{{ page.text }}</p>
                  </div>
                </div>

                <div
                  v-if="page.layout == 2"
                  class="d-flex flex-column justify-content-between py-4 h-100"
                >
                  <h4
                    class="mx-auto"
                    style="letter-spacing: 0.5px; max-width: 250px;"
                    v-html="page.title"
                  ></h4>
                  <div
                    style="font-size: 3.5rem; line-height: 1.5;"
                    :class="'icon-'+ page.icon"
                  >
                  </div>
                  <div class="px-2">{{ page.text }}</div>
                </div>

                <div
                  v-if="page.pending"
                  class="card-overlay"
                  style="background-color: rgba(255,255,255,.25);"
                >
                  <div class="card-body">
                    <div class="spinner">
                      <div class="bounce1"></div>
                      <div class="bounce2"></div>
                      <div class="bounce3"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="showAddOns"
            class="row justify-content-center"
            style="margin-right: 0px !important; margin-left: 0px !important;"
          >
            <div
              v-for="addon in addons"
              :key="addon.Id"
              class="col-6 col-sm-4 col-md-3 col-xl-2"
              style="margin-bottom: 20px; padding: 0 12px !important;"
            >
              <add-on-tile :addon="addon" :show="true"></add-on-tile>
            </div>
          </div>
        </div>
        <div
          id="modal"
          class="modal fade"
          tabindex="-1"
          role="dialog"
          aria-hidden="true"
        >
          <div
            class="modal-dialog modal-lg"
            role="document"
          >
            <div class="modal-content">
              <div class="modal-body text-center py-11">
                <a
                  role="button"
                  class="icon-close float-right h2"
                  style="top: -2rem;"
                  data-dismiss="modal"
                  aria-hidden="true"
                ></a>
                <h3>KONFIGURER HJEMMESIDER</h3>
                <hr
                  class="my-4"
                  style="width: 100px; border-color: #808080; margin: 0 auto"
                />
                <h5 class="mb-5">Din salong bruker fortsatt vår gamle hjemmesideløsning</h5>

                <p>
                  Klikk på "Gå til vår nye hjemmeside-konfigurasjon" for å finne ut hvor enkelt du kan
                  sette opp en moderne hjemmeside eller "Gå til gammel løsning" for å gjøre endringer
                  på din eksisterende hjemmeside.
                </p>

                <div class="mt-5">
                  <a
                    role="button"
                    class="btn btn-outline-secondary border-0"
                    @click="openCmsOverview"
                  >GÅ TIL GAMMEL LØSNING</a>
                  <button
                    role="button"
                    class="btn btn-primary"
                    data-dismiss="modal"
                    @click="openHomepageConfiguration"
                  >GÅ TIL VÅR NYE HJEMMESIDELØSNING</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </v-container>
</template>

<script>
import AddOnTile from './components/AddOnTile'
import { webshopAddOn } from '@/constants/addons'
export default {
  components: {
    AddOnTile
  },
  props: {
    showAddOns: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    show: true,
    CONFIG: window.CONFIG,
    pages: [],
    pending: false,
    webshopAddOnId: webshopAddOn
  }),
  methods: {
    openHomepageConfiguration () {
      window.location.href = '#location=homepage'
    },
    openCmsOverview () {
      window.location.href = this.CONFIG.fixitOnlineUrls.getUrl('CmsOverview')
    },
    async getCmsConfig (page) {
      page.pending = true
      let cmsConfig = await this.$store.dispatch(
        'global/getCmsConfigByChainId',
        {
          chainId: this.CONFIG.user.ChainId,
          isDraft: 1
        }
      )
      page.pending = false
      if (cmsConfig) {
        if (cmsConfig.CmsFixitNoEnabled) {
          // Go to hjemmeside.[env]
          if (this.CONFIG.homepageIds.length) {
            this.$router.push('hjemmeside-innstillinger')
          } else {
            window.location.href = '#location=homepageeditor'
          }
        } else if (cmsConfig.CmsEnabled) {
          // NB! This assumes that JQuery is defined in document
          // eslint-disable-next-line no-undef
          $('#modal').modal({
            backdrop: 'static'
          })
        } else {
          this.$router.push('hjemmeside-innstillinger')
        }
      } else {
        this.$router.push('hjemmeside-innstillinger')
      }
    },
    redirectToArticles () {
      window.location.href = '#location=articles'
      window.location.reload()
    },
    pageClicked (page) {
      if (page.type === 'vue') return this.$router.push(page.page)

      if (page.title === 'Hjemmeside') return this.getCmsConfig(page)
      if (page.href) {
        window.location.href =
          page.href === '/StockImageAdmin'
            ? '/StockImageAdmin'
            : this.CONFIG.fixitOnlineUrls.getUrl(page.href)
      } else {
        window.location.href = '#location=' + page.page
        window.location.reload()
      }
    },
    userHasRole (role) {
      var predicate = Array.isArray(role)
        ? function (r) {
          return ~role.indexOf(r.RoleName)
        }
        : function (r) {
          return role === r.RoleName
        }
      var hasRole = this.CONFIG.user.UserRoles.filter(predicate).length > 0
      return hasRole
    },
    getSubscriptionStatus() {
      return this.subscriptionStatus
    }
  },
  computed: {
    filteredPages () {
      return this.pages.filter(
        page =>
          (page.visible == null ? true : page.visible) &&
          this.userHasRole(page.roles || ['User'])
      )
    },
    addons () {
      return this.$store.getters['addons/getAddOns']
    },
    subscriptionStatus () {
      return this.$store.getters['addons/getActivationStatusForAddon'](this.webshopAddOnId)
    }
  },
  created () {
    let vm = this
      this.show = false
      this.$store.dispatch('addons/fetchAddOns').then(() => {
        vm.show = true
        this.addons.forEach(addOn => {
          this.$store.dispatch('addons/fetchAddOnSubscriptions', { chainId: window.CONFIG.user.ChainId, addOnId: addOn.Id })
        })
      })
    this.pages = [
      {
        title: 'Kasse',
        icon: 'chain',
        roles: ['BookingConsole'],
        type: 'vue',
        page: 'point-of-sale',
        text: 'Edit POS Settings',
        imageType: 14,
        imageFk: 'FixITOnlineBilder/avdelinger',
        visible: false
      },
      {
        title: 'Kjede',
        icon: 'chain',
        roles: ['BookingConsole'],
        page: 'departments',
        text: 'Rediger innholdet på de ulike salongene.',
        imageType: 14,
        imageFk: 'FixITOnlineBilder/avdelinger',
        visible: this.CONFIG.departments.length > 1
      },
      {
        title: 'Salongen',
        icon: 'shop',
        roles: ['BookingConsole'],
        page: 'department',
        text: 'Rediger innholdet på innlogget salong.',
        imageType: 14,
        imageFk: 'FixITOnlineBilder/avdeling'
      },
      {
        title: 'Ansatte',
        icon: 'group',
        roles: ['BookingConsole'],
        page: 'employees',
        text: 'Administrer bilder og beskrivelser for dine ansatte.',
        imageType: 14,
        imageFk: 'FixITOnlineBilder/ansatte'
      },
      {
        title: 'Booking',
        icon: 'smartphone',
        roles: ['BookingConsole'],
        page: 'booking',
        text: 'Innstillinger for booking.',
        imageType: 14,
        imageFk: 'FixITOnlineBilder/booking'
      },
      {
        title: 'Hjemmeside',
        icon: 'homepage',
        roles: ['CMS'],
        page: '',
        text: 'Konfigurer salongens hjemmeside.',
        imageType: 14,
        imageFk: 'FixITOnlineBilder/hjemmeside',
        pending: false,
        visible: true
      },
      {
        title: 'Intranett',
        icon: 'chat',
        roles: ['Employee'],
        page: '',
        href: 'CommunicationBlog_Overview',
        text: 'Kommuniser med dine ansatte',
        imageType: 14,
        imageFk: 'FixITOnlineBilder/intranett'
      },
      {
        title: 'Fordelsprogram',
        icon: 'loyalty',
        roles: ['BookingConsole'],
        page: '',
        href: 'MarketingLoyaltyPrograms',
        text: 'Opprett eller endre fordelsprogram.',
        imageType: 14,
        imageFk: 'FixITOnlineBilder/fordelsprogram'
      },
      {
        title: 'Bruker-administrasjon',
        icon: 'useradmin',
        page: '',
        href: 'IntranetAdministration',
        text: 'Bruker-administrasjon',
        imageType: 14,
        imageFk: 'FixITOnlineBilder/brukere'
      },
      {
        title: 'Systemstatus',
        icon: 'systemstatus',
        roles: ['BookingConsole'],
        page: '',
        href: 'MarketingStatusActivation',
        text: 'Systemstatus',
        imageType: 14,
        imageFk: 'FixITOnlineBilder/system'
      },
      {
        title: 'Stock-bilder',
        icon: 'stockimage',
        roles: ['OdinGlobalAdmin'],
        href: '/StockImageAdmin',
        text:
          'Opplasting av stock-bilder til bruk i bildegalleri. Kun for Odin-ansatte.',
        imageType: 14,
        imageFk: 'FixITOnlineBilder/avdeling'
      },
      {
        title: 'GDPR-veiviser',
        icon: 'giftcard',
        page: 'gdpr-one-click',
        query: { context: 'menu' },
        text: 'GDPR - One click',
        roles: ['User']
      },
      {
        title: 'Gavekort',
        icon: 'giftcard',
        page: 'giftcard',
        text:
          'Endre innstillinger for tjenesten. Opprett og rediger digitale gavekort.',
        imageType: 14,
        imageFk: 'FixITOnlineBilder/avdelinger',
        roles: ['ChainUser']
      },
      {
        title: 'Nettbutikk',
        icon: 'mdi-cart',
        page: 'giftcard',
        roles: ['ChainUser', 'User'],
        material: true,
        isAddon: true,
        addonId: 1,
        visible: this.subscriptionStatus === 2
      },
      {
        title: 'FixIT Nettbestilling',
        icon: 'systemstatus',
        roles: ['ChainUser', 'User'],
        href: 'MarketingTPN',
        text:
          'FixIT Nettbestilling',
        imageType: 14,
        imageFk: 'FixITOnlineBilder/system'
      },
      {
        title: 'Gruppering av leiestoler',
        icon: 'chair',
        roles: ['ChainUser', 'User'],
        href: 'RentalChair',
        text: 'Gruppering av leiestoler'
      }
    ]
  }
}
</script>
<style>
</style>
